import React from 'react';
import { MapPin } from 'lucide-react';
import { COMPANY_INFO } from '../../mock';

export const BundesweitSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Reichweite
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Bundesweit im Einsatz
          </h2>
        </div>

        <div className="bg-white border border-gray-200 rounded-3xl p-10 lg:p-12 shadow-lg">
          <div className="flex items-start gap-6 mb-8">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center border border-brand-green/15">
                <MapPin className="w-8 h-8 text-brand-green" />
              </div>
            </div>
            <div className="flex-1">
              <p className="text-gray-700 leading-relaxed text-lg mb-6">
                Wir sind <strong>bundesweit tätig</strong>. Die Terminvergabe erfolgt zentral, sodass Begutachtungen kurzfristig und ortsunabhängig koordiniert werden können.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Je nach Region kommen wir direkt zu Ihnen oder stimmen einen passenden Vor-Ort-Termin ab. Sie müssen nicht zu uns fahren – wir organisieren die Begutachtung dort, wo es für Sie am günstigsten ist.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 border border-gray-100 rounded-2xl p-6 text-center">
            <p className="text-gray-600 text-lg">
              <strong>Bundesweite Verfügbarkeit</strong> – kontaktieren Sie uns für eine Terminabstimmung.
            </p>
            <p className="text-gray-900 font-semibold mt-4">
              <a href={`tel:${COMPANY_INFO.phone}`} className="text-brand-green hover:text-brand-green-dark transition-colors">Jetzt anrufen</a>
            </p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a href="/bundesweit" className="text-brand-green hover:text-brand-green-dark font-semibold text-lg transition-colors">
            Mehr über unsere bundesweite Reichweite →
          </a>
        </div>
      </div>
    </section>
  );
};